export default {
  title: 'handler',
  lazy: true,
  labelWidth: '100px',
  items: [{
    name: 'handler',
    items: [{
      name: 'needLogin',
      type: 'switch',
      text: '需要登录',
      defaultValue: false,
    }, {
      name: 'actions',
      type: 'table',
      columns: [{
        label: '自定义功能',
        name: 'fuc',
        type: 'code',
        language: 'javascript',
      }],
    }],
  }],
};
